import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	closeModalTitle: {
		id: 'proforma-panel-in-issue-view-ui.controllers.use-handle-close-form.close-modal-title',
		defaultMessage: 'Close customer edits on this form',
		description:
			'The title of the modal asking the user to confirm if they want to close the form.',
	},
	closeModalBody: {
		id: 'proforma-panel-in-issue-view-ui.controllers.use-handle-close-form.close-modal-body',
		defaultMessage:
			'Customers will no longer be able to edit this form and it will be submitted in its current state.',
		description:
			'The body content of the modal asking the user to confirm if they want to close the form.',
	},
	closeFormModalTitle: {
		id: 'proforma-panel-in-issue-view-ui.controllers.use-handle-close-form.close-form-modal-title',
		defaultMessage: 'Close edits on this form',
		description:
			'The title of the modal asking the user to confirm if they want to close the form (non JSM projects).',
	},
	closeFormModalBody: {
		id: 'proforma-panel-in-issue-view-ui.controllers.use-handle-close-form.close-form-modal-body',
		defaultMessage: 'Closing edits will submit this form in its current state. ',
		description:
			'The body content of the modal asking the user to confirm if they want to close the form (non JSM projects).',
	},
	closeModalConfirm: {
		id: 'proforma-panel-in-issue-view-ui.controllers.use-handle-close-form.close-modal-confirm',
		defaultMessage: 'Close edits',
		description:
			'The text in the confirmation button of the modal asking the user to confirm if they want to close the form.',
	},
	closeModalCancel: {
		id: 'proforma-panel-in-issue-view-ui.controllers.use-handle-close-form.close-modal-cancel',
		defaultMessage: 'Cancel',
		description:
			'The text in the cancel button of the modal asking the user to confirm if they want to close the form.',
	},
});
